if(typeof require !== 'undefined'){
  var Helpers = require('../Helpers.js');
  var moment = require('moment');
}


// This all needs to move to a require / module style
const LoanFormParser = {
  parse: function(rawLoan){
    var loan = {
      amount: Helpers.getFloatFromString(rawLoan.amount),
      date: LoanFormParser._prepareDate(rawLoan),
      loan_type: rawLoan.loan_type,
      pmi_monthly: rawLoan.pmi_monthly,
      rate: rawLoan.rate,
      status: rawLoan.status || 'current',
    };

    if(loan.loan_type === 'HELOC')
      return loan;

    if(LoanFormParser._isAdjustable(rawLoan))
      return LoanFormParser._addAdjustableProperties(loan, rawLoan);

    return LoanFormParser._addFixedProperties(loan, rawLoan);
  },

  parseForEditing: function(mortgage){
    var loan = _.cloneDeep(mortgage);
    loan.pmi_monthly = loan.pmi_monthly && parseFloat(loan.pmi_monthly);
    loan.year = moment(loan.date).format('YYYY');
    loan.month = moment(loan.date).format('MMMM');
    loan.term = LoanFormParser.createTerm(loan);
    loan.rate = loan.rate || loan.rateEstimated;

    return loan;
  },

  createTerm: function(loan){
    if(loan.adjustable)
      return 'ARM' + (loan.arm_years_initial || 5) + 'YR';
    else
      return 'FIX' + (loan.termYears || loan.termYearsEstimated) + 'YR';
  },

  _addAdjustableProperties: function(loan, rawLoan){
    loan.adjustable = true;
    loan.arm_years_initial = Helpers.getIntFromString(rawLoan.term);
    return loan;
  },

  _addFixedProperties: function(loan, rawLoan){
    loan.adjustable = false;
    loan.termYears = Helpers.getIntFromString(rawLoan.term);
    return loan;
  },

  _isAdjustable: function(loan){
    return loan.term.indexOf('ARM') !== -1;
  },

  _prepareDate: function(loan){
    return moment()
      .year(loan.year)
      .month(loan.month)
      .date(1)
      .format(Helpers.dateFormat);
  }
};

if(typeof module !== 'undefined' && module.exports){
  module.exports = LoanFormParser;
}else if(typeof window !== 'undefined'){
  window.LoanFormParser = LoanFormParser;
}
